// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Curry from "../../../../../node_modules/rescript/lib/es6/curry.js";
import * as React from "react";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as ReactModal from "react-modal";
import * as RnrAssetManager from "../../assets/RnrAssetManager.bs.js";
import * as RnrModalsHelper from "../helpers/RnrModalsHelper.bs.js";
import * as DateTime$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/utils/DateTime.bs.js";
import * as RnrCouponAwardView from "../RnrCouponAwardView.bs.js";

var giftIcon = RnrAssetManager.getImage("gift_icon.svg");

var carIcon = RnrAssetManager.getImage("car.svg");

var hcvIcon = RnrAssetManager.getImage("hcv_icon.svg");

var truckIcon = RnrAssetManager.getImage("truck_icon.svg");

var animation = RnrAssetManager.getImage("starSuccess.json");

function getAwardView(title, detail, icon) {
  return React.createElement("div", {
              className: "award-detail-component__container"
            }, icon !== undefined ? React.createElement("div", {
                    className: "award-detail-component__icon-box"
                  }, React.createElement("img", {
                        className: "award-detail-component__icon",
                        src: icon
                      })) : null, React.createElement("div", {
                  className: "award-detail-component__title"
                }, title), React.createElement("div", {
                  className: "award-detail-component__detail"
                }, detail));
}

function get2WAwardView(content) {
  return getAwardView(content.default2WAward.modalTitle, content.default2WAward.modalText, undefined);
}

function getMahindraAwardViewLCV(content) {
  return getAwardView(content.defaultLCVAward.modalTitle, content.defaultLCVAward.modalText, undefined);
}

function getMahindraAwardViewHCV(content) {
  return getAwardView(content.defaultHCVAward.modalTitle, content.defaultHCVAward.modalText, undefined);
}

function getFuelAwardView(award, content) {
  return getAwardView(Curry._1(content.getFuelAwardModalTitle, String(award.fuelQuantity)), Curry._1(content.getFuelAwardModalText, String(award.amount)), giftIcon);
}

function getCouponAwardView(award, content, milestone) {
  return React.createElement(RnrCouponAwardView.make, {
              content: content,
              coupon: award,
              milestone: milestone
            });
}

function getPremiumnessAwardView(award, content) {
  return getAwardView(Curry._1(content.getPremiumnessAwardModalTitle, String(award.acceptAdvantage)), Curry._3(content.getPremiumnessAwardModalText, String(award.acceptAdvantage), DateTime$Catalyst.toString("DD MMM YYYY", award.startDate), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate)), giftIcon);
}

function getRewardMultiplierAwardView(award, content) {
  return getAwardView(Curry._1(content.getRewardMultiplierAwardModalTitle, award.multiplier.toString() + "X"), Curry._3(content.getRewardMultiplierAwardModalText, award.multiplier.toString() + "X", DateTime$Catalyst.toString("DD MMM YYYY", award.startDate), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate)), giftIcon);
}

function getNoAwardView(content) {
  return getAwardView(content.noAward.modalTitle, content.noAward.modalText, giftIcon);
}

function getMonetaryAwardView(award, content) {
  return getAwardView(Curry._1(content.getMonetaryAwardModalTitle, String(award.amount)), Curry._1(content.getMonetaryAwardModalText, String(award.amount)), giftIcon);
}

function getInsuranceAwardView(award, content) {
  var match = award.benefit_type;
  return getAwardView(content.insuranceAward.modalTitle, match ? Curry._2(content.getInsuranceAwardModalDiscountText, String(Belt_Option.getWithDefault(award.discount, 0)), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate)) : Curry._2(content.getInsuranceAwardModalText, String(Belt_Option.getWithDefault(award.price, 0)), DateTime$Catalyst.toString("DD MMM YYYY", award.endDate)), giftIcon);
}

function getDistributionCeremonyAwardView(content) {
  return getAwardView(content.distributionCeremonyAward.modalTitle, content.distributionCeremonyAward.modalText, giftIcon);
}

function getFinalAwardView(content) {
  return getAwardView(content.finalAward.modalTitle, content.finalAward.modalText, giftIcon);
}

function getAwardDetailView(award, content, milestone, vehicleCategory) {
  if (typeof award === "number") {
    switch (vehicleCategory) {
      case /* LCV */0 :
          return getMahindraAwardViewLCV(content);
      case /* HCV */1 :
          return getMahindraAwardViewHCV(content);
      case /* TwoWheeler */2 :
          return get2WAwardView(content);
      
    }
  } else {
    switch (award.TAG | 0) {
      case /* Fuel */0 :
          return getFuelAwardView(award._0, content);
      case /* Premiumness */1 :
          return getPremiumnessAwardView(award._0, content);
      case /* RewardMultiplier */2 :
          return getRewardMultiplierAwardView(award._0, content);
      case /* NoAward */3 :
          return getNoAwardView(content);
      case /* Monetary */4 :
          return getMonetaryAwardView(award._0, content);
      case /* Insurance */5 :
          return getInsuranceAwardView(award._0, content);
      case /* DistributionCeremony */6 :
          return getDistributionCeremonyAwardView(content);
      case /* Final */7 :
          return getFinalAwardView(content);
      case /* Coupon */8 :
          return getCouponAwardView(award._0, content, milestone);
      
    }
  }
}

function closeModalHandler(param) {
  window.history.back();
  
}

function RnrAwardDetailModal(Props) {
  var milestone = Props.milestone;
  var viewModel = Props.viewModel;
  var content = Props.content;
  var checkavailabilityOpt = Props.checkavailability;
  var checkavailability = checkavailabilityOpt !== undefined ? checkavailabilityOpt : true;
  return React.createElement(ReactModal, {
              isOpen: true,
              onRequestClose: (function (param) {
                  window.history.back();
                  
                }),
              overlayClassName: "award-detail-modal__overlay",
              className: "award-detail-modal__content",
              shouldCloseOnOverlayClick: false,
              children: React.createElement("div", {
                    className: "award-detail-component"
                  }, getAwardDetailView(RnrModalsHelper.getAward(viewModel.milestoneDetails, milestone, checkavailability), content, milestone, viewModel.vehicleCategory), React.createElement("div", {
                        className: "award-detail-component__close-button",
                        onClick: (function (param) {
                            window.history.back();
                            
                          })
                      }, "X"))
            });
}

var make = RnrAwardDetailModal;

export {
  giftIcon ,
  carIcon ,
  hcvIcon ,
  truckIcon ,
  animation ,
  getAwardView ,
  get2WAwardView ,
  getMahindraAwardViewLCV ,
  getMahindraAwardViewHCV ,
  getFuelAwardView ,
  getCouponAwardView ,
  getPremiumnessAwardView ,
  getRewardMultiplierAwardView ,
  getNoAwardView ,
  getMonetaryAwardView ,
  getInsuranceAwardView ,
  getDistributionCeremonyAwardView ,
  getFinalAwardView ,
  getAwardDetailView ,
  closeModalHandler ,
  make ,
  
}
/* giftIcon Not a pure module */
